import { Typography } from "@mui/material";
import { MdError } from "@teamworksdev/icons";
import type { PropsWithChildren, ReactElement } from "react";
import { cn } from "../../utils";

interface DataTablePlaceholderProps {
  variant?: "default" | "error";
  icon?: ReactElement;
  title?: string;
  description?: string;
  className?: string;
}
export const DataTablePlaceholder = ({
  variant = "default",
  icon,
  title,
  description,
  children,
  className,
}: PropsWithChildren<DataTablePlaceholderProps>) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center text-center py-20",
      className
    )}
  >
    <div
      className={cn(
        "bg-black flex h-10 w-10 items-center justify-center mb-4 rounded-full text-center text-white",
        {
          "bg-error-700": variant === "error",
        }
      )}
    >
      {icon ||
        (variant === "error" && <MdError size={20} className="text-white" />)}
    </div>

    <Typography
      variant="h4"
      component="h2"
      className={cn("text-base font-semibold mb-1", {
        "text-error-700": variant === "error",
      })}
    >
      {title}
    </Typography>
    <p className="mb-6 max-w-96 text-sm w-full text-black text-opacity-60">
      {description}
    </p>
    {children}
  </div>
);
